// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"App_spinnerContainer__2Qcqz"};